import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'uploads';
let baseUrl = config.apiBaseUrl;

export default {
  // REST endpoints
  getAll(where, limit) {
    let query = '';

    if(where) {
      query += query === '' ? '?' : '&';
      query += 'where=' + JSON.stringify(where);
    }

    if(limit) {
      query += query === '' ? '?' : '&';
      query += 'limit=' + limit;
    }

    return axios.get(baseUrl + '/' + restModel + query, RequestConfig);
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },

  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  signUpload(data) {
    return axios.post(baseUrl + '/' + restModel + '/sign-upload', data, RequestConfig);
  },

  getSignedDownload(uploadId) {
    return axios.get(baseUrl + '/' + restModel + '/get-signed-download/' + uploadId, RequestConfig);
  }
}
